import React from 'react';
import { FormattedMessage } from 'react-intl';
import NumberControl from "@rio-cloud/rio-uikit/lib/es/NumberControl";

interface InputProps {
    hasError?: boolean;
    errorMsg?: string;
    label?: string;
    placeholder?: string;
    [key: string]: any; // Accept additional props for NumberControl
}

const NumberInputOTA: React.FC<InputProps> = ({
                                                  hasError = false,
                                                  errorMsg,
                                                  label,
                                                  placeholder,
                                                  ...rest
                                              }) => {
    const containerClass = hasError ? 'form-group has-feedback has-error' : 'form-group';

    return (
        <>
            {label && <label><FormattedMessage id={label} /></label>}

            <div className={containerClass}>
                <FormattedMessage id={placeholder || ''}>
                    {translatedPlaceholder => (
                        <NumberControl
                            placeholder={translatedPlaceholder}
                            {...rest}
                        />
                    )}
                </FormattedMessage>
            </div>

            {hasError && (
                <div className="form-group has-feedback has-error padding-bottom-15">
                    <span className="help-block">
                        <FormattedMessage id={errorMsg || 'intl-msg:form:requiredField'} />
                    </span>
                </div>
            )}
        </>
    );
};

export default NumberInputOTA;
